import { useYearPickerContext } from '@/domain/mitarbeiter/features/feiertagskonto/shared/YearPickerContext';
import { DateNavigator } from '@e2n/ui/v2';
import dayjs from 'dayjs';

export function YearPicker() {
  const { year, setYear } = useYearPickerContext();
  const handleSelectedYear = (selectedYear: Date) => {
    setYear(dayjs(selectedYear));
  };

  return (
    <DateNavigator
      granularity="year"
      onChange={handleSelectedYear}
      onGrey={false}
      value={year.toDate()}
    />
  );
}
